import { BaseComponent } from '../base-component'
import { $el, $elParent } from 'src/scripts/utils/utils'

const INPUT_SELECTOR = `[data-search-field-input]`
const RESET_BTN_SELECTOR = `[data-search-field-reset-button]`

export class SearchField extends BaseComponent {
  mountComponent(): void {
    const resetButton = $el(RESET_BTN_SELECTOR, this)
    const input: HTMLInputElement = $el(INPUT_SELECTOR, this)

    this.addListener(input, 'input', this.handleInputChange)
    this.addListener(window, 'click', this.handleWindowClick)
    this.addListener(resetButton, 'click', this.handleResetButtonClick)
  }

  handleWindowClick = (event: MouseEvent): void => {
    const input: HTMLInputElement = $el(INPUT_SELECTOR, this)
    const target = event.target as HTMLElement
    const isInputChild = $elParent('search-input', target)
    const isInput = input === target

    if (!isInput && !isInputChild) {
      this.updateResetButtonVisible()
    }
  }

  handleInputChange = (): void => {
    this.updateResetButtonVisible()
  }

  handleResetButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.reset()
  }

  reset(): void {
    const input: HTMLInputElement = $el(INPUT_SELECTOR, this)

    if (input) {
      input.value = ''
      input.dispatchEvent(new Event('input', { bubbles: true }))
      input.focus()
    }
  }

  updateResetButtonVisible(): void {
    const resetButton = $el(RESET_BTN_SELECTOR, this)

    if (resetButton) {
      resetButton.classList.toggle('hidden', !this.hasInputValue())
    }
  }

  hasInputValue(): boolean {
    const input: HTMLInputElement = $el(INPUT_SELECTOR, this)
    return input ? input.value.trim().length > 0 : false
  }

  get value(): string {
    const input: HTMLInputElement = $el(INPUT_SELECTOR, this)
    return input ? input.value : ''
  }
}
